import React from 'react';

interface TabItem {
  title: string;
  key: string;
  iconUrl?: string;
}

interface Props {
  items: TabItem[];
  selected: string;
  selectKey: Function
}

const ButtonMenu: React.FC<Props> = ({ items, selected, selectKey }) => {

  const inactiveClasses = 'cursor-pointer hover:text-primary-400 opacity-70';
  // const activeClasses = 'underline underline-offset-8 text-primary-500'
  const activeClasses = 'bg-indigo-800'

  const click = (item: TabItem) => {
    selectKey(item.key);
  }

  return (
    <>
      {/* Tab headers */}
      <div className="flex items-center justify-between bg-indigo-700 rounded-full text-gray-100" style={{padding: 2}}>
          {items.map((item, index) => (
            <div key={"tab_" + index}
              className={"flex p-2 rounded-full justify-center items-center w-full " + (item.key === selected ? activeClasses : inactiveClasses)}
              onClick={() => click(item)}
            >
              <div className="flex items-center">
                {
                  item.iconUrl &&
                    <img src={item.iconUrl} className="h-4 mr-2" alt="icon" />
                }
                <div className="font-medium">{item.title}</div>
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default ButtonMenu;